module.exports = __webpack_public_path__ + "2ed910820347c1e38beaada92e48440d.jpg";